import { IRangeValue, TAdditionalServicesValue, TRoomsValue } from '../quiz';

export interface IRequestFormV2Meta {
  showRequestForm: boolean;
  requiresAuth: boolean;
}

export type TFormRoomCount = null | TRoomsValue[];

export type TFormPriceRange = null | IRangeValue;

export type TFormAdditionalServices = null | TAdditionalServicesValue;

export interface IRequestFormV2Quiz {
  roomCount: TFormRoomCount;
  priceRange: TFormPriceRange;
  additionalServices: TFormAdditionalServices;
}

export enum EFormStep {
  Rooms = 'rooms',
  Prices = 'prices',
  AdditionalServices = 'additionalServices',
  PhoneVerification = 'phoneVerification',
  Contacts = 'contacts',
  BookingExists = 'bookingExists',
  Error = 'error',
  Success = 'success',
}

export enum EFormStatus {
  Interactive = 'interactive',
  Submitting = 'submitting',
}

export interface IRequestFormV2Form {
  phone: string | null;
  requirements: string | null;
  region: IRegion | null;
}

export interface IRegion {
  id: number;
  label: string;
}

export interface IRequestFormV2PhoneVerification {
  code: string | null;
  secondsToRetry: number;
  lastAttemptTimestamp: number | null;
}

export interface IRequestFormV2 {
  step: EFormStep;
  status: EFormStatus;
  meta: IRequestFormV2Meta;
  quiz: IRequestFormV2Quiz;
  form: IRequestFormV2Form;
  errors: IRequestFormV2Errors;
  phoneVerification: IRequestFormV2PhoneVerification;
}

export interface IRequestFormV2Errors {
  phone?: string | null;
  phoneVerification?: string | null;
}
